import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { UpdateKeyValueAsync } from "source/app/infrastructure/Data/KeyValues/UpdateKeyValue";
import { dispatchSetFunctionState } from "source/app/presentation/Shared/SharedTypes";
import { ArrayUtils } from "source/app/services/ArrayUtils";
import { Sounds } from "source/app/services/Sound/Sounds";
import { IStackFocusState } from "source/app/presentation/BottomBar/BottomLeftDashboard/Stack/IStackFocusState";
import { IKeyValue } from "motw_core/Entity/IKeyValue";
import { ReadState } from "source/app/services/UI/State/ReadState";

export function ToggleProblemHashTag(
    problemHashTag: string,
    setState?: dispatchSetFunctionState<IStackFocusState>
) {
    const keyValue = ReadState<IKeyValue>(
        ESharedFunction.StackFocus_criticalHashTags
    );

    const criticalHashTags = keyValue?.value
        ? (JSON.parse(keyValue.value) as string[])
        : [];

    const isCritical = criticalHashTags.includes(problemHashTag);
    const newCriticalHashTags = isCritical
        ? ArrayUtils.Exclude(criticalHashTags, problemHashTag)
        : ArrayUtils.AddToWithoutRepeating(criticalHashTags, problemHashTag);

    isCritical
        ? Sounds.switchbulb_soft.Play({ allowConcurrent: true })
        : Sounds.switchbulb_loud.Play({ allowConcurrent: true });

    if (setState) {
        setState((prevState) => ({
            ...prevState,
            criticalHashTags: newCriticalHashTags,
        }));
    }

    UpdateKeyValueAsync(
        ESharedFunction.StackFocus_criticalHashTags,
        JSON.stringify(newCriticalHashTags)
    );

    return newCriticalHashTags;
}
